"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
require("core-js/modules/es6.function.name");
const react_1 = __importDefault(require("react"));
const atoms_1 = require("@components/atoms");
const Input_1 = require("@components/atoms/Input");
const Modal_1 = require("@components/atoms/Modal");
const _utils_1 = require("@utils");
const _api_1 = __importDefault(require("@api"));
const _store_1 = __importDefault(require("@store"));
var AddressForm = function AddressForm(_ref) {
    var address = _ref.address, refreshAddresses = _ref.refreshAddresses, forceDefault = _ref.forceDefault;
    var _useGlobal = _store_1.default(function (state) {
        return state.user;
    }), user = _useGlobal[0];
    var _React$useState = react_1.default.useState((address === null || address === void 0 ? void 0 : address.type) || 'home'), type = _React$useState[0], setType = _React$useState[1];
    var _React$useState2 = react_1.default.useState((address === null || address === void 0 ? void 0 : address.firstName) || (user === null || user === void 0 ? void 0 : user.firstName)), firstName = _React$useState2[0], setFirstName = _React$useState2[1];
    var _React$useState3 = react_1.default.useState((address === null || address === void 0 ? void 0 : address.lastName) || (user === null || user === void 0 ? void 0 : user.lastName)), lastName = _React$useState3[0], setLastName = _React$useState3[1];
    var _React$useState4 = react_1.default.useState(address === null || address === void 0 ? void 0 : address.streetOne), streetOne = _React$useState4[0], setStreetOne = _React$useState4[1];
    var _React$useState5 = react_1.default.useState(address === null || address === void 0 ? void 0 : address.streetTwo), streetTwo = _React$useState5[0], setStreetTwo = _React$useState5[1];
    var _React$useState6 = react_1.default.useState(address === null || address === void 0 ? void 0 : address.city), city = _React$useState6[0], setCity = _React$useState6[1];
    var _React$useState7 = react_1.default.useState(address === null || address === void 0 ? void 0 : address.state), state = _React$useState7[0], setState = _React$useState7[1];
    var _React$useState8 = react_1.default.useState(address === null || address === void 0 ? void 0 : address.postalCode), postalCode = _React$useState8[0], setPostalCode = _React$useState8[1];
    var _React$useState9 = react_1.default.useState((address === null || address === void 0 ? void 0 : address.nation) || 'United States of America'), nation = _React$useState9[0], setNation = _React$useState9[1];
    var _React$useState10 = react_1.default.useState((address === null || address === void 0 ? void 0 : address.phone) || (user === null || user === void 0 ? void 0 : user.phone)), phone = _React$useState10[0], setPhone = _React$useState10[1];
    var _React$useState11 = react_1.default.useState(forceDefault || (address === null || address === void 0 ? void 0 : address.default) || false), defaultAddress = _React$useState11[0], setDefaultAddress = _React$useState11[1];
    var _React$useState12 = react_1.default.useState(false), processing = _React$useState12[0], setProcessing = _React$useState12[1];
    var _React$useState13 = react_1.default.useState(['home', 'mailing']), addressTypes = _React$useState13[0], setAddressTypes = _React$useState13[1];
    react_1.default.useEffect(function () {
        _api_1.default('listAddresses').then(function (response) {
            response.json().then(function (addresses) {
                var unusedAddresses = addressTypes.filter(function (a) {
                    return addresses.map(function (a) {
                        return a.type;
                    }).indexOf(a) < 0;
                });
                if (address)
                    unusedAddresses.push(address.type);
                setAddressTypes(unusedAddresses);
                setType(address ? address.type : unusedAddresses[0]);
            });
        });
    }, []);
    var formEnabled = function formEnabled() {
        var pass = true;
        var inputs = [streetOne, city, state, postalCode, nation];
        inputs.map(function (val) {
            if (pass)
                pass = val !== undefined && val !== "";
        });
        return pass;
    };
    var createAddress = function createAddress() {
        var action = (address === null || address === void 0 ? void 0 : address.id) ? 'updateAddress' : 'createAddress';
        setProcessing(true);
        _api_1.default(action, {
            id: address === null || address === void 0 ? void 0 : address.id,
            type: type,
            firstName: firstName,
            lastName: lastName,
            streetOne: streetOne,
            streetTwo: streetTwo,
            city: city,
            state: state,
            postalCode: postalCode,
            nation: nation,
            phone: phone,
            default: !!defaultAddress
        }).then(function () {
            setProcessing(false);
            refreshAddresses();
        });
    };
    var parsedNations = _utils_1.nations.map(function (n) {
        return n.name;
    });
    return /*#__PURE__*/ react_1.default.createElement(Modal_1.ModalWrapper, null, /*#__PURE__*/ react_1.default.createElement(Modal_1.ModalContent, null, /*#__PURE__*/ react_1.default.createElement(Modal_1.ModalCopy, null, /*#__PURE__*/ react_1.default.createElement(Modal_1.ModalHeadline, null, (address === null || address === void 0 ? void 0 : address.id) ? 'Edit Address' : 'Add Address'), /*#__PURE__*/ react_1.default.createElement(Modal_1.ModalSubhead, null, "Please fill out the following: ", type, " ")), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "select",
        value: type,
        label: "Address Type",
        name: "type",
        onChange: function onChange(_ref2) {
            var value = _ref2.target.value;
            return setType(value);
        },
        required: true,
        disabled: processing,
        options: addressTypes
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, {
        split: "tablet"
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        value: firstName,
        label: "First Name",
        name: "firstName",
        onChange: function onChange(_ref3) {
            var value = _ref3.target.value;
            return setFirstName(value);
        },
        required: true,
        disabled: processing
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        value: lastName,
        label: "Last Name",
        name: "lastName",
        onChange: function onChange(_ref4) {
            var value = _ref4.target.value;
            return setLastName(value);
        },
        required: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        value: streetOne,
        label: "Street Address",
        name: "streetOne",
        onChange: function onChange(_ref5) {
            var value = _ref5.target.value;
            return setStreetOne(value);
        },
        required: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        value: streetTwo,
        label: "Apt. / Suite / Bldg.",
        name: "streetTwo",
        onChange: function onChange(_ref6) {
            var value = _ref6.target.value;
            return setStreetTwo(value);
        },
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        value: city,
        label: "City",
        name: "city",
        onChange: function onChange(_ref7) {
            var value = _ref7.target.value;
            return setCity(value);
        },
        required: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, {
        split: "tablet"
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        value: state,
        label: "State or Province",
        name: "state",
        onChange: function onChange(_ref8) {
            var value = _ref8.target.value;
            return setState(value);
        },
        required: true,
        disabled: processing
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        value: postalCode,
        label: "Postal Code",
        name: "postalCode",
        onChange: function onChange(_ref9) {
            var value = _ref9.target.value;
            return setPostalCode(value);
        },
        required: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "select",
        value: nation,
        label: "Nation",
        name: "nation",
        onChange: function onChange(_ref10) {
            var value = _ref10.target.value;
            return setNation(value);
        },
        required: true,
        disabled: processing,
        options: parsedNations
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "tel",
        value: phone,
        label: "Phone Number",
        name: "phone",
        onChange: setPhone,
        disabled: processing
    })), !forceDefault && /*#__PURE__*/ react_1.default.createElement(atoms_1.InputCheckbox, {
        name: "defaultAddress",
        onChange: function onChange() {
            return setDefaultAddress(!defaultAddress);
        },
        checked: defaultAddress || false,
        outline: true,
        largeLabel: true
    }, "Make this my default address"), /*#__PURE__*/ react_1.default.createElement(Modal_1.ModalButtonWrapper, null, !address && /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, Object.assign({
        shadow: true,
        size: "large",
        display: "flex",
        onClick: function onClick() {
            return createAddress();
        }
    }, {
        processing: processing
    }, {
        disabled: !formEnabled()
    }), "Add Address")), address && /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, Object.assign({
        shadow: true,
        size: "large",
        display: "flex",
        onClick: function onClick() {
            return createAddress();
        }
    }, {
        processing: processing
    }, {
        disabled: !formEnabled()
    }), "Save Changes")))));
}; // Typing
exports.default = AddressForm;
